var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 672,
    height: 588,
    viewBox: "0 0 672 588",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M491.094 559.59H4V4H647.73V428.589",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M271.08 435.527C249.822 427.882 232.839 416.559 220.121 401.563C207.401 386.575 200.696 368.517 200 347.405H295.12C296.508 359.338 301.213 368.446 309.232 374.713C317.242 380.988 327.695 384.123 340.59 384.123C353.828 384.123 364.281 381.449 371.948 376.089C379.609 370.739 383.447 363.317 383.447 353.83C383.447 345.876 380.395 339.3 374.302 334.094C368.201 328.894 360.711 324.614 351.827 321.243C342.944 317.88 330.308 314.057 313.936 309.768C290.238 303.343 270.898 296.916 255.923 290.491C240.937 284.066 228.043 274.586 217.247 262.035C206.445 249.492 201.046 233.12 201.046 212.925C201.046 182.942 213.41 159.455 238.153 142.473C262.889 125.491 295.121 117 334.842 117C375.258 117 407.834 125.491 432.576 142.473C457.311 159.456 470.55 183.092 472.297 213.384H375.608C374.906 202.986 370.554 194.796 362.541 188.83C354.523 182.862 344.249 179.879 331.706 179.879C320.901 179.879 312.188 182.403 305.572 187.451C298.95 192.5 295.643 199.772 295.643 209.253C295.643 219.659 301.21 227.77 312.369 233.578C323.513 239.395 340.931 245.67 364.633 252.397C388.321 259.439 407.568 266.167 422.382 272.591C437.19 279.016 449.993 288.355 460.799 300.589C471.594 312.83 477 328.587 477 347.864C477 366.223 471.683 382.903 461.059 397.892C450.428 412.887 435.008 424.821 414.805 433.691C394.595 442.57 370.726 447 343.204 447C316.369 447 292.328 443.178 271.08 435.527H271.079L271.08 435.527Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M572.228 453.562H518.413V564.088H572.228V453.562Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M652.791 453.562H518.413V498.582H652.791V453.562Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M572.522 469.116L536.145 500.95L635.62 588L671.998 556.166L572.522 469.116Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectLogo);
export default __webpack_public_path__ + "static/media/Select_Logo.afa14f4e70bc0a7a69c046a1db115087.svg";
export { ForwardRef as ReactComponent };